import { render } from "./IconList.vue?vue&type=template&id=1c4e7a8f"
import script from "./IconList.vue?vue&type=script&lang=js"
export * from "./IconList.vue?vue&type=script&lang=js"

import "./IconList.vue?vue&type=style&index=0&id=1c4e7a8f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__